"use client"

import {Geist} from "next/font/google";
import "./globals.css";
import {Header} from "./components/header/header";
import {ThemeProvider} from "@mui/material";
import {theme} from "./theme";
import {Footer} from "./components/footer/footer";
import styles from "./layout.module.css";

const geistSans = Geist({
  variable: "--font-geist-sans",
  subsets: ["latin"]
});

export default function RootLayout({
                                     children,
                                   }: Readonly<{
  children: React.ReactNode;
}>) {
  return (
      <html lang="de">
      <head>
        <title>IOV | Internationale Organisation Völkerrecht</title>
        <link rel="apple-touch-icon" sizes="180x180" href="/favicon/apple-touch-icon.png"/>
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon/favicon-32x32.png"/>
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon/favicon-16x16.png"/>
        <link rel="manifest" href="/favicon/site.webmanifest"/>
      </head>
      <body className={geistSans.variable}>
      <ThemeProvider theme={theme}>
        <div className={styles.page}>
          <Header/>
          <main className={styles.content}>
            {children}
            <Footer/>
          </main>
        </div>
      </ThemeProvider>
      </body>
      </html>
  );
}
